import { Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { authGuard, permissionGuard } from './core/guards';

export const routes: Routes = [
  {
    path: 'account',
    loadChildren: () => import('./features/account/account.routes').then((m) => m.routes),
  },
  {
    path: 'login',
    redirectTo: 'account/login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./features/features.routes').then((m) => m.routes),
    canActivate: [authGuard],
    // Declared once here: `data.permission` is parent-merged, so every descendant is covered
    // and no feature route file can forget to attach a guard.
    canActivateChild: [permissionGuard],
  },
];
